import { Injectable } from '@angular/core';
import { MyActivity, MyDefaultActivity, MyDailyValue, DurationTimeActivity } from '../interfaces/activity';


@Injectable({
  providedIn: 'root'
})
export class HelperService {
    getLocalZoneISOString(date: Date): string {
        return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
    }
}